/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CameraLayoutType {
    Undefined = 0,
    Single = 1,
    BSS = 2,
    BSSS = 3,
    Quad = 4,
    PictureInPicture = 5,
    TwoByThree = 6,
    TwinView = 7,
    ThreeByThree = 9,
}
